import { Icon } from 'assets/index'
import { EditPicture } from '..'
import Card from './style'

interface IHeaderPageProps {
  path: string
}

export default function ActionCard(props: IHeaderPageProps) {
  const { path } = props

  return (
    <Card>
      <div className="header-page-left">
        <span>{path}</span>
      </div>
      <div className="header-page-right">
        <EditPicture revert name="Fernando Lemos" />
      </div>
    </Card>
  )
}
